import { select, observe, parseDuration } from './_util.js';

/**
 * Parse text nodes and wrap each word with a span
 *
 * @param {HTMLElement} node
 */
function prepare( node ) {
	node.classList.add( 'animated-words' );
	node.childNodes.forEach( child => {
		switch ( child.nodeType ) {
			case 3: // Text
				const masks = child.textContent.split( ' ' ).reduce(
					( masks, word, wordIndex ) => {
						if ( wordIndex > 0 ) {
							masks.push( document.createTextNode( ' ' ) );
						}

						const mask = document.createElement( 'span' );
						mask.classList.add( 'animated-words__mask' );

						const wordNode = document.createElement( 'span' );
						wordNode.classList.add( 'animated-words__word' );
						wordNode.appendChild( document.createTextNode( word ) );

						mask.appendChild( wordNode );
						masks.push( mask );

						return masks;
					},
					[]
				);

				node.removeChild( child );
				masks.forEach( mask => node.appendChild( mask ) );
			break;
			default:
				prepareWordsNode( child );
			break;
		}
	} );
}

/**
 * Animate each word of a node in individually
 *
 * @param {String|Array|NodeList|HTMLElement} selector
 * @param {Object} opts
 * @returns {Array}
 */
export function words( selector, opts = {} ) {
	opts = {
		delay: 200,
		interval: 100,
		duration: null,
		threshold: 50,
		...opts
	};

	return select( selector ).map( ( node ) => {
		prepare( node );

		const words = node.querySelectorAll( '.animated-words__word' );

		if ( opts.duration ) {
			opts.duration = parseDuration( opts.duration );
			words.forEach( word => word.style.animationDuration = opts.duration );
		}

		return observe( node, { threshold: opts.threshold } ).then( () => {
			setTimeout(
				() => {
					words.forEach( ( word, i ) => {
						setTimeout(
							() => word.classList.add( 'animated-words__word--visible' ),
							opts.interval * ( i + 1 )
						);
					} );
				},
				opts.delay
			)
		} );
	} );
}
